<div class="app-dialog" [class.app-dialog--error]="kind === 'error'"
     [class.app-dialog--info]="kind === 'info'"
     [class.app-dialog--quiz]="kind === 'quiz'">

  <!-- ============ Cabeçalho ============ -->
  <header class="app-dialog__header">
    <span class="app-dialog__chip" aria-hidden="true">
      <span nz-icon
            [nzType]="kind === 'error' ? 'close-circle' : kind === 'info' ? 'warning' : 'question-circle'"
            nzTheme="outline"></span>
    </span>

    <h2 class="app-dialog__title">
      <ng-container [ngSwitch]="kind">
        <ng-container *ngSwitchCase="'error'">Ops! Aconteceu um erro.</ng-container>
        <ng-container *ngSwitchCase="'info'">Informação</ng-container>
        <ng-container *ngSwitchDefault>{{ data?.title | translateTA }}</ng-container>
      </ng-container>
    </h2>
  </header>

  <!-- ============ Conteúdo ============ -->
  <div class="app-dialog__body">

    <p class="app-dialog__status" *ngIf="kind === 'error' && data.status && data.status !== '0'">
      Código do erro: <strong>{{ data.status }}</strong>
    </p>

    <p class="app-dialog__lead" *ngIf="kind === 'error'">
      Alguma coisa deu errado ao processar a operação.
    </p>

    <div class="app-dialog__message">
      {{ data?.message | translateTA }}
    </div>
  </div>

  <!-- ============ Ações ============ -->
  <footer class="app-dialog__actions">
    <ng-container *ngIf="kind === 'quiz'; else singleAction">
      <button nz-button nzType="default" (click)="close(false)">
        {{ data.btnNao | translateTA }}
      </button>
      <button nz-button nzType="primary" (click)="close(true)">
        {{ data.btnSim | translateTA }}
      </button>
    </ng-container>
    <ng-template #singleAction>
      <button nz-button nzType="primary" (click)="close()">Fechar</button>
    </ng-template>
  </footer>
</div>